<template>
  <div class="show-report">
    <van-sticky>
      <van-nav-bar :title="testingVO.name" />
    </van-sticky>
    <div>
      <img class="bg" src="https://kangpingoss.oss-cn-beijing.aliyuncs.com/images/testing6/1.png"/>
      <img class="bg" src="https://kangpingoss.oss-cn-beijing.aliyuncs.com/images/testing6/2.png"/>
      <img class="bg" src="https://kangpingoss.oss-cn-beijing.aliyuncs.com/images/testing6/3.png"/>
      <img class="bg" src="https://kangpingoss.oss-cn-beijing.aliyuncs.com/images/testing6/4.png"/>
      <!-- <div class="bottom">
        <div>北京康萍科技有限公司</div>
        <div>京ICP备17029900号-1</div>
      </div> -->
    </div>
    <!-- 进行中检测 -->
    <div class="ing-record">
      <div v-for="(item,index) in ingRecordList" :key="index" @click="itemClick(item)" class="block">
        <div class="circle">{{ item.testingName }}未完成</div>
      </div>
    </div>
    <div class="button-container">
      <div class="price-info">
        <div v-if="amount > 0" class="amount">
          ￥{{ amount }}元起
        </div>
        <div v-if="originalAmount > 0" class="original-amount">原价：￥{{ originalAmount }}元</div>
      </div>
      <div @click="showTest" class="button animated infinite">
        <div>立即测试</div>
      </div>
    </div>
    <van-action-sheet v-model="show" title="选择检测版本">
      <div>
        <van-radio-group v-model="checked">
          <van-cell-group inset>
            <van-cell v-if="testingMap[6]" :title="testingMap[6].name2" clickable @click="checked = '6'">
              <template #title>
                <span class="custom-title">{{ testingMap[6].name2 }}</span>&nbsp;&nbsp;
                <van-tag type="danger">￥{{ testingMap[6].amount }}元</van-tag>
              </template>
              <template #right-icon>
                <van-radio name="6" />
              </template>
            </van-cell>
            <van-cell v-if="testingMap[7]" clickable @click="checked = '7'">
              <template #title>
                <span class="custom-title">{{ testingMap[7].name2 }}</span>&nbsp;&nbsp;
                <van-tag type="danger">￥{{ testingMap[7].amount }}元</van-tag>
              </template>
              <template #right-icon>
                <van-radio name="7" />
              </template>
            </van-cell>
          </van-cell-group>
          <!-- 立即检测 -->
          <div class="content">
            <div @click="testing" class="mt40 button">立即测试</div>
          </div>
        </van-radio-group>
      </div>
    </van-action-sheet>
    <div class="recent">
      <van-notice-bar :scrollable="false" background="#F3EAF3">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="2000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item,index) in recentList" :key="index">{{ item }}</van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>
    <div class="flex-col-center button-tools">
      <div @click="toIndex">首页</div>
      <div @click="toRecord">报告</div>
    </div>
  </div>
</template>

<script>
// 移除meta
import axios from "axios"
import { detail } from '@/api/testing'
import { auth, h5Pay, h5PayResult, fetchIngRecord, recentRecord } from '@/api/testing-record'
import { fetchUserInfo } from '@/api/user'
import { fetchTesting } from '@/api/testing'
import { duration } from '@/api/page-duration'
import { isWeiXin, saveEvent } from '@/utils/tools'
import { Toast } from "vant";
export default {
  components: {
  },
  data() {
    return {
      recentList: [],
      durationUid: '',
      location: 0,
      amount: -1,
      originalAmount: -1,
      ingRecordList: [],
      testingMap: {},
      checked: '',
      show: false,
      timer: null,
      durationTimer: null,
      payOrderId: '',
      testingVO: {},
      testingId: '6'
    };
  },
  watch: {
    $route() {
      this.init()
    }
  },
  mounted() {
  },
  created() {
    localStorage.setItem('Route', '/welcome6')
    localStorage.setItem('welcome-url', '')
    if (this.$route.query.companyId && this.$route.query.companyId != localStorage.getItem('CompanyId')) {
      localStorage.setItem('CompanyId', this.$route.query.companyId)
      window.location.reload()
    }
    this.checked = this.testingId
    if (localStorage.getItem('testingId')) {
      this.checked = localStorage.getItem('testingId')
    }
    this.init()
  },
  methods: {
    showTest() {
      this.show = true
      saveEvent('show-testing')
    },
    async init() {
      if (localStorage.getItem('reload')) {
        localStorage.removeItem('reload')
        window.location.reload()
      }
      await detail({
        testingId: this.checked
      }).then(res => {
        this.testingVO = res
      })
      await fetchTesting({}).then(res => {
        res.content.forEach(it => {
          this.testingMap[it.id] = it
          if (this.amount < 0 || this.amount > it.amount) {
            this.amount = it.amount
            this.originalAmount = it.original
          }
        })
      })
      // 进行中
      await fetchIngRecord().then(res => {
        this.ingRecordList = res
      })
      // 最近购买记录
      await recentRecord().then(res => {
        this.recentList = res
      })
      if (this.payOrderId || localStorage.getItem('payOrderId')) {
        clearInterval(this.timer)
        if (localStorage.getItem('payOrderId')) {
          this.payOrderId = localStorage.getItem('payOrderId')
        }
        this.timer = setInterval(() => {
          this.timerFunction()
        }, 1000)
      }
      // 计算有效高
      var totalH = document.body.scrollHeight || document.documentElement.scrollHeight
      // 可视高
      var clientH = window.innerHeight || document.documentElement.clientHeight
      window.addEventListener("scroll", (e) => {
        // 计算有效高
        var validH = totalH - clientH;
        // 滚动条卷去高度
        var scrollH =
            document.body.scrollTop || document.documentElement.scrollTop;
        // 百分比
        var result = ((scrollH / validH) * 100).toFixed(2);
        this.location = result
      })
      // 停留时长timer
      clearInterval(this.durationTimer)
      this.durationTimer = setInterval(() => {
        this.durationTimerFunction()
      }, 1000)
    },
    toOld() {
      // 去老版
      // location.href = 'https://kpapi.kpjkgl.com/H5/#/homePage'
      var sign = this.$md5(localStorage.getItem('tel') + 'kangping').substring(8, 24)
      console.info(sign)
      axios({
          method: 'post',
          url: 'https://ai.kpjkgl.com:444/userLogin/loginAllow?userId='+ localStorage.getItem('tel') +'&md5Tag='+ sign +'&channelName=kangping'
      })
      .then(response => {
        console.info(response)
        if (response.data.code == 200) {
          var data = response.data.data
          location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId=' + data.userId + '&role=' + data.role + '&allow=' + data.allow
        } else{
          // 提示语
          Toast(response.data.msg)
        }
      })
    },
    durationTimerFunction() {
      duration({
        uid: this.durationUid,
        location: this.location
      }).then(res => {
        this.durationUid = res
        localStorage.setItem('Uid', res)
      }, err => {
        console.info(err)
        clearInterval(this.durationTimer)
      })
    },
    timerFunction() {
      // 保存跳转
      localStorage.setItem('welcome-url', location.href + '&t=' + new Date().getMilliseconds())
      h5PayResult({
        testingId: this.checked,
        payOrderId: this.payOrderId ? this.payOrderId : localStorage.getItem('payOrderId') ? localStorage.getItem('payOrderId') : ''
      }).then(res => {
        if (res && res.id) {
          clearInterval(this.timer)
          // 保存
          this.payOrderId = ''
          localStorage.setItem('payOrderId', '')
          if (res.state.key == 'Succeed') {
            // 进行中
            if (localStorage.getItem('testingId') == '7') {
              this.toOld()
              return false
            } else {
              this.payOrderId = res.id
              // 成功了
              this.$router.push({
                path: '/testing-info',
                query: {
                  testingId: this.checked,
                  testingRecordId: res.relationId
                }
              })
            }
          }
        }
      }, err => {
        console.info(err)
        clearInterval(this.timer)
      })
    },
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    },
    toRecord() {
      this.$router.push({
        path: '/testing-record'
      })
    },
    itemClick(item) {
      fetchUserInfo().then(res => {
        if (item.testingId == 7) {
          window.location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId='+ localStorage.getItem('Tel') +'&inspectOrder='+ item.times +'&role=1&allow=true&companyId='+ item.companyId +'&isEdit=1'
          // var sign = this.$md5(res.tel + 'kangping').substring(8, 24)
          // axios({
          //     method: 'post',
          //     url: 'https://ai.kpjkgl.com:444/userLogin/loginAllow?userId='+ res.tel +'&md5Tag='+ sign +'&channelName=kangping'
          // })
          // .then(response => {
          //   if (response.data.code == 200) {
          //     var data = response.data.data
          //     location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId=' + data.userId + '&role=' + data.role + '&allow=' + data.allow
          //   } else{
          //     // 提示语
          //     Toast(response.data.msg)
          //   }
          // })
          return false
        } else {
          this.$router.push({
            path: '/testing-info',
            query: {
              testingId: item.testingId,
              testingRecordId: item.id
            }
          })
        }
      })
    },
    testing() {
      saveEvent('click-testing', {
        testingId: this.checked
      })
      // 保存跳转
      localStorage.setItem('welcome-url', location.href + '&t=' + new Date().getMilliseconds())
      // 判断登录
      fetchUserInfo().then(info => {
        localStorage.setItem('tel', info.tel)
        // 继续操作
        if (isWeiXin()) {
          localStorage.setItem('testingId', this.checked)
          // 公众号支付
          auth({
            testingId: this.checked
          }).then(res => {
            localStorage.setItem('payOrderId', '')
            window.location.href = res
          })
        } else {
          h5Pay({
            testingId: this.checked,
            payOrderId: this.payOrderId ? this.payOrderId : localStorage.getItem('payOrderId') ? localStorage.getItem('payOrderId') : ''
          }).then(res => {
            this.payOrderId = res.id
            localStorage.setItem('payOrderId', res.id)
            localStorage.setItem('testingId', this.checked)
            // 保存
            if (res.state.key == 'Succeed') {
              // 成功了
              if (localStorage.getItem('testingId') == '7') {
                // 去老版
                this.toOld()
                return false
              } else {
                this.$router.push({
                  path: '/testing-info',
                  query: {
                    testingId: this.checked,
                    testingRecordId: res.relationId
                  }
                })
              }
            } else {
              // 跳转支付
              location.href = res.payJson + '&redirect_url=' + encodeURIComponent(location.href + '&t=' + new Date().getMilliseconds())
            }
          })
        }
      })
    }
  }
};
</script>

<style scoped lang="less">
.show-report {
  // width: 100%;
  // height: 100%;
  .bg {
    width: 100%;
    margin-bottom: 124px;
  }
  .line {
    height: 20px;
  }
}
.button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 18px 40px;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.price-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.ing-record {
  z-index: 999;
  position: fixed;
  bottom: 320px;
  left: 0;
  padding: 0 40px;
  // .item {
  //   font-size: 0.32rem;
  //   color: #fff;
  //   margin-top: 24px;
  //   padding: 8px 24px;
  //   border-radius: 24px;
  //   background: rgba(0, 0, 0, 0.7);
  // }
  .block {
    font-size: 0.24rem;
    color: #fff;
    margin-top: 24px;
    padding: 8px 24px;
    border-radius: 24px;
  }

  @keyframes twinkling {
      0% {
          opacity: 0.2;
          filter: alpha(opacity=20);
          transform: scale(1);
      }

      50% {
          opacity: 0.5;
          filter: alpha(opacity=50);
          transform: scale(1.12);
      }

      100% {
          opacity: 0.2;
          filter: alpha(opacity=20);
          transform: scale(1);
      }
  }


  .circle {
    display: flex;
    align-items: center;
    text-align: center;
    width: 104px;
    height: 120px;
    border-radius: 50%;
    background: #3a96e1;
    text-align: center;
    position: relative;
    padding: 0 8px;
    z-index: 1;
  }

  .circle::before {
      background: inherit;
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: -2;
      border-radius: 50%;
      animation: twinkling 1.2s ease-in-out infinite;
  }

  .circle::after {
      background: inherit;
      content: '';
      position: absolute;
      width: 120%;
      height: 120%;
      left: -10%;
      top: -10%;
      z-index: -1;
      border-radius: 50%;
      animation: twinkling 1.2s ease-in-out infinite;
  }
}
.content {
  padding: 40px;
}
.mt40 {
  margin-top: 40px;
}

.button {
  padding: 0 104px;
  height: 84px;
  line-height: 84px;
  font-size: 32px;
  font-weight: bold;
  background: #ff9e19;
  color: #fff;
  text-align: center;
  border-radius: 48px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both
}
 
.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite
}
 
.flash {
  -webkit-animation-name: flash;
  animation-name: flash
}
 
@-webkit-keyframes flash {
 /*只用修改这里就可以实现不同动画。例如大小闪烁transform: scale(.9);*/
  0%,
  100%,
  50% {
    opacity: 1;
    transform: scale(1);
  }
 
  25%,
  75% {
    opacity: 0.4;
    transform: scale(.9);
  }
}
 
@keyframes flash {
 
  0%,
  100%,
  50% {
    opacity: 1;
    transform: scale(1);
  }
 
  25%,
  75% {
    opacity: 0.4;
    transform: scale(.9);
  }
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both
}
 
.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite
}
 
.flash {
  -webkit-animation-name: flash;
  animation-name: flash
}
 
@-webkit-keyframes flash {
 /*只用修改这里就可以实现不同动画。例如大小闪烁transform: scale(.9);*/
  0%,
  100%,
  50% {
    opacity: 1;
    transform: scale(1);
  }
 
  25%,
  75% {
    opacity: 0.4;
    transform: scale(.9);
  }
}
 
@keyframes flash {
 
  0%,
  100%,
  50% {
    opacity: 1;
    transform: scale(1);
  }
 
  25%,
  75% {
    opacity: 0.4;
    transform: scale(.9);
  }
}

.amount {
  font-size: 32px;
  color: #ff9e19;
  font-weight: bold;
}

.original-amount {
  font-size: 14px;
  text-decoration: line-through;
  font-weight: bold;
}

.bottom {
  padding-bottom: 120px;
  width: 100%;
  text-align: center;
  font-size: .32rem;
  color: #333;
  div {
    margin-bottom: 8px;
  }
}
.recent {
  position: fixed;
  left: 80px;
  right: 80px;
  bottom: 200px;
  height: 60px;
  .van-notice-bar {
    border-radius: 48px;
    height: 60px;
  }
  .notice-swipe {
    margin: 0;
    height: 40px;
    line-height: 40px;
  }
  .van-swipe-item {
    font-size: 0.32rem;
  }
}
</style>
